import styled from "styled-components";
const Pill = styled.button<{ active: boolean}>`
  background: ${(props) => (props.active ? "#ffffff" : "#000d30")};
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  border: none;
  color: ${(props) => (props.active ? "black" : "white")};
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
  font-size: 16px;

  @media screen and (max-width: 1400px) {
  font-size: 12px;
  }
`;
export default Pill;
